import { buildManageRouteWithSchoolYear } from '../manage/manageSchoolYearRouting';

export function settlementContextKey({ user, schoolYearStartYear, personal }) {
  return JSON.stringify([user.id || '', user.schoolId || '', user.role || '', user.teacherId || '', user.activeContextKey || '',
    user.systemRoles || [], schoolYearStartYear, Boolean(personal)]);
}

export function currentSettlementReturn(returnLocation, user, schoolYearStartYear) {
  const state = returnLocation && returnLocation.state && returnLocation.state.teacherSettlementView;
  if (!state || !['/manage/my-settlements', '/manage/reports/settlements'].includes(returnLocation.pathname)) return null;
  const personal = returnLocation.pathname === '/manage/my-settlements';
  return state.contextKey === settlementContextKey({ user, schoolYearStartYear, personal }) ? returnLocation : null;
}

export function settlementReturnState({ contextKey, month, expandedTeacherIds, expandedGroupKeys, missingOnly, alertsOnly, withLessonsOnly, searchQuery, scroll }) {
  return { contextKey,
    month,
    expandedTeacherIds: expandedTeacherIds.slice(),
    expandedGroupKeys: expandedGroupKeys.slice(),
    missingOnly: Boolean(missingOnly),
    alertsOnly: Boolean(alertsOnly),
    withLessonsOnly: Boolean(withLessonsOnly),
    searchQuery: String(searchQuery || '').slice(0, 200),
    scroll };
}

export function settlementAttendanceLocation(lesson, returnLocation, search, schoolYearStartYear) {
  if (lesson.canAccessAttendance !== true || !lesson.schoolClassId || !Number.isInteger(lesson.baseIndex) || lesson.baseIndex < 0) return null;
  return { ...buildManageRouteWithSchoolYear(`/manage/class/${encodeURIComponent(lesson.schoolClassId)}/lesson/${lesson.baseIndex}/attendance`, search, schoolYearStartYear),
    state: { settlementReturn: returnLocation, attendanceDate: lesson.attendanceDate || lesson.date } };
}

export function isPlainNavigationClick(event) {
  return event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;
}
